import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useNavbarInitiative } from "@hooks/useNavbarInitiative";
import { usePaginatedList } from "@hooks/usePaginatedList";
import UserItem from "../UsersGroups/components/UserItem";
import { useUsersGroupsActions } from "../UsersGroups/hooks/useUsersGroupsActions";
import { buildUGListUrl } from "../UsersGroups/types";
import PanelList from "./PanelList";

const PAGE_SIZE = 5;

export default function UsersPanel() {
  const { id: corporateId = "" } = useParams();
  const { selectedInitiative } = useNavbarInitiative();

  const listUrl = useMemo(
    () => buildUGListUrl("users", corporateId),
    [corporateId],
  );

  const filters = useMemo(
    () => ({
      page: 1,
      pageSize: PAGE_SIZE,
      sort: "most-recent",
      fieldFilters:
        selectedInitiative && selectedInitiative !== "all"
          ? { initiative_id: selectedInitiative }
          : undefined,
    }),
    [selectedInitiative],
  );

  const { items, isLoading, mutate } = usePaginatedList(listUrl, filters);

  const { userActions, modals } = useUsersGroupsActions({
    corporateId,
    onRefresh: () => mutate && mutate(),
  });

  return (
    <>
      <PanelList isLoading={isLoading} isEmpty={items.length === 0}>
        {items.map((user: any) => (
          <UserItem
            key={`user-${user.id_user}`}
            user={user}
            corporateId={corporateId}
            selectable={false}
            {...userActions}
          />
        ))}
      </PanelList>
      {modals}
    </>
  );
}
